module.exports = __webpack_public_path__ + "assets/img/jiqiren.0e5cb120.png";